import { Typography, Hidden, Box, Button, Breadcrumbs, Link } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Redirect,
  Route,
  Router,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router';
import RelationshipManagers from './relationShipManagers';
import { UserManagementCommonLayout } from '../commonComponents';
import Distributors from './Distributors';
import InviteRmDetails from './inviteRm';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import AddDistributor from './addDistributors';
import Trustees from './Trustees';
import AddTrustee from './addTrustee';
import FundManagers from './FundManagers';
import AddFundManager from './addFundManagers';
import aifApprover from './aifApprover';
import AddAIFApprover from './addAifApprover';
import ListCompanyDistributors from './companyDistributors';
import MappedSrmsForRm from './srmsInRm';
import MappedPlansForIMAndTrustee from './plansForTrusteeAndIM';
import RMDetails from './viewRM';
import UserManagementDistributorDetails from './viewDistributor';
import TrusteeDetails from './viewTrustee';
import IMDetails from './viewIm';
import AIFApproverDetails from './viewAIFApprover';
import amcAdmin from './amcAdmin';
import AmcAdminDetails from './viewAmcAdmin';
import AddAmcAdmin from './addAmcAdmin';
import { useDispatch } from 'react-redux';
import {
  exportUsers,
  getAIFApproverList,
  getAmcAdminList,
  getDistributorsList,
  getFundManagersList,
  getRMsList,
  getTrustessList,
} from '../../redux-store/actions/userManagement';
import { newRmType } from '../../redux-store/types/api-types';
import { downloadBlobFile } from '../../utils/utilityFunctions';

export function IdDependencyRoutes({
  idDetails,
  path,
  component,
  replaceUrl,
}: {
  idDetails: any;
  path: string;
  component: React.ComponentType<any>;
  replaceUrl: string;
}): JSX.Element {
  const history = useHistory();
  useEffect(() => {
    if (!idDetails) {
      history.replace(replaceUrl);
    }
  }, []);

  return (
    <Router history={history}>
      <Switch>
        <Route path={path} component={component} />
      </Switch>
    </Router>
  );
}

function Routes({ historyLocationState }: { historyLocationState: any }): JSX.Element {
  const history = useHistory();
  const { path } = useRouteMatch();

  return (
    <Router history={history}>
      <Switch>
        <Route
          exact
          path={path}
          render={() => <Redirect to={`${path}/relationship-managers`} from={location?.pathname} />}
        />
        <Route path={`${path}/relationship-managers`} component={RelationshipManagers} />
        <Route path={`${path}/distributors`} component={Distributors} />
        <Route path={`${path}/trustee`} component={Trustees} />
        <Route path={`${path}/invest-managers`} component={FundManagers} />
        <Route path={`${path}/aif-approver`} component={aifApprover} />
        <Route path={`${path}/amc-admin`} component={amcAdmin} />
        <IdDependencyRoutes
          idDetails={historyLocationState}
          path={`${path}/edit-aifapprover`}
          component={AddAIFApprover}
          replaceUrl={'/user-management'}
        />
        <Route path={`${path}/add-aif-approver`} component={AddAIFApprover} />
        <IdDependencyRoutes
          idDetails={historyLocationState}
          path={`${path}/edit-trustee`}
          component={AddTrustee}
          replaceUrl={'/user-management'}
        />
        <Route path={`${path}/add-Invest-manager`} component={AddFundManager} />
        <IdDependencyRoutes
          idDetails={historyLocationState}
          path={`${path}/edit-Invest-manager`}
          component={AddFundManager}
          replaceUrl={'/user-management'}
        />
        <IdDependencyRoutes
          idDetails={historyLocationState}
          path={`${path}/edit-distributor`}
          component={AddDistributor}
          replaceUrl={'/user-management'}
        />
        <Route path={`${path}/add-trustee`} component={AddTrustee} />
        <Route path={`${path}/invite-rm-details`} component={InviteRmDetails} />
        <IdDependencyRoutes
          idDetails={historyLocationState}
          path={`${path}/edit-rm-details`}
          component={InviteRmDetails}
          replaceUrl={'/user-management'}
        />
        <Route path={`${path}/add-distributor`} component={AddDistributor} />
        <Route path={`${path}/distributor`} component={ListCompanyDistributors} />
        <IdDependencyRoutes
          idDetails={historyLocationState}
          path={`${path}/srms`}
          component={MappedSrmsForRm}
          replaceUrl={'/user-management'}
        />
        <IdDependencyRoutes
          idDetails={historyLocationState}
          path={`${path}/trustee-plans`}
          component={MappedPlansForIMAndTrustee}
          replaceUrl={'/user-management'}
        />
        <IdDependencyRoutes
          idDetails={historyLocationState}
          path={`${path}/IM-plans`}
          component={MappedPlansForIMAndTrustee}
          replaceUrl={'/user-management'}
        />
        <IdDependencyRoutes
          idDetails={historyLocationState}
          path={`${path}/relationship-manager-details`}
          component={RMDetails}
          replaceUrl={'/user-management'}
        />
        <IdDependencyRoutes
          idDetails={historyLocationState}
          path={`${path}/distributor-details`}
          component={UserManagementDistributorDetails}
          replaceUrl={'/user-management'}
        />
        <IdDependencyRoutes
          idDetails={historyLocationState}
          path={`${path}/trustee-details`}
          component={TrusteeDetails}
          replaceUrl={'/user-management'}
        />
        <IdDependencyRoutes
          idDetails={historyLocationState}
          path={`${path}/Invest-manager-details`}
          component={IMDetails}
          replaceUrl={'/user-management'}
        />
        <IdDependencyRoutes
          idDetails={historyLocationState}
          path={`${path}/aif-approver-details`}
          component={AIFApproverDetails}
          replaceUrl={'/user-management'}
        />
        <IdDependencyRoutes
          idDetails={historyLocationState}
          path={`${path}/amc-admin-details`}
          component={AmcAdminDetails}
          replaceUrl={'/user-management'}
        />
        <Route path={`${path}/add-amc-admin`} component={AddAmcAdmin} />
        <IdDependencyRoutes
          idDetails={historyLocationState}
          path={`${path}/edit-amc-admin`}
          component={AddAmcAdmin}
          replaceUrl={'/user-management'}
        />
      </Switch>
    </Router>
  );
}

type TabItem = {
  title: string;
  routerLink: string;
  countKey: keyof TabCounts;
};

type TabCounts = {
  rms: number;
  distributors: number;
  trustees: number;
  ims: number;
  aifApprovers: number;
  amcAdmins: number;
};

function UserManagementLayOutItems({
  item,
  link,
  count,
}: {
  item: string;
  link: string;
  count?: number;
}) {
  const history = useHistory();
  const location = useLocation<{ trusteeId: number; IMId: number }>();
  const { trusteeId, IMId } = location.state || {};
  const pathLink = history.location.pathname.includes(link);
  return (
    <Box
      component={RouterLink}
      to={{ pathname: `${link}`, state: { trusteeId, IMId } }}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        px: { sm: 1.5, md: 2 },
        py: 2,
        textDecoration: 'none',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        borderBottom: pathLink ? '3px solid #2057A6' : '3px solid transparent',
        color: pathLink ? '#2057A6' : '#6B7280',
        fontFamily: 'Inter, sans-serif',
        fontWeight: pathLink ? 600 : 500,
        fontSize: 14,
        lineHeight: 1,
        letterSpacing: 0,
        '&:hover': {
          color: '#2057A6',
        },
      }}>
      {item}
      {typeof count === 'number' && (
        <Box
          component="span"
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: 28,
            height: 22,
            px: 0.75,
            borderRadius: '9999px',
            bgcolor: pathLink ? '#E8F0FE' : '#F3F4F6',
            color: pathLink ? '#2057A6' : '#6B7280',
            fontFamily: 'Inter, sans-serif',
            fontSize: 12,
            fontWeight: 600,
            lineHeight: 1,
          }}>
          {count}
        </Box>
      )}
    </Box>
  );
}

export default function UserManagementLayOut(): JSX.Element {
  const history = useHistory();
  const dispatch = useDispatch();
  const pathName = history.location.pathname;
  const { path } = useRouteMatch();
  const [tabCounts, setTabCounts] = useState<TabCounts>({
    rms: 0,
    distributors: 0,
    trustees: 0,
    ims: 0,
    aifApprovers: 0,
    amcAdmins: 0,
  });

  const links = [
    `${path}/relationship-managers`,
    `${path}/distributors`,
    `${path}/trustee`,
    `${path}/invest-managers`,
    `${path}/aif-approver`,
    `${path}/amc-admin`,
  ];
  const items: TabItem[] = [
    { title: 'Relationship Managers', routerLink: `relationship-managers`, countKey: 'rms' },
    { title: 'Distributors', routerLink: `distributors`, countKey: 'distributors' },
    { title: 'Trustees', routerLink: `trustee`, countKey: 'trustees' },
    { title: 'Investment Managers', routerLink: `invest-managers`, countKey: 'ims' },
    { title: 'AIF Approvers', routerLink: `aif-approver`, countKey: 'aifApprovers' },
    { title: 'AMC Admins', routerLink: `amc-admin`, countKey: 'amcAdmins' },
  ];

  const MenulinksSrms = [
    `${path}/srms`,
    `${path}/distributors`,
    `${path}/trustee`,
    `${path}/invest-managers`,
    `${path}/aif-approver`,
    `${path}/amc-admin`,
  ];
  const MenuItemsSrms: TabItem[] = [
    { title: 'Relationship Managers', routerLink: `srms`, countKey: 'rms' },
    ...items.slice(1),
  ];

  const MenulinksTrusteePlans = [
    `${path}/relationship-managers`,
    `${path}/distributors`,
    `${path}/trustee-plans`,
    `${path}/invest-managers`,
    `${path}/aif-approver`,
    `${path}/amc-admin`,
  ];
  const MenuItemsTrusteePlans: TabItem[] = [
    items[0],
    items[1],
    { title: 'Trustees', routerLink: `trustee-plans`, countKey: 'trustees' },
    ...items.slice(3),
  ];

  const MenulinksIMPlans = [
    `${path}/relationship-managers`,
    `${path}/distributors`,
    `${path}/trustee`,
    `${path}/IM-plans`,
    `${path}/aif-approver`,
    `${path}/amc-admin`,
  ];
  const MenuItemsIMPlans: TabItem[] = [
    items[0],
    items[1],
    items[2],
    { title: 'Investment Managers', routerLink: `IM-plans`, countKey: 'ims' },
    ...items.slice(4),
  ];

  const Menulinks = links.includes(pathName)
    ? links
    : MenulinksSrms.includes(pathName)
    ? MenulinksSrms
    : MenulinksTrusteePlans.includes(pathName)
    ? MenulinksTrusteePlans
    : MenulinksIMPlans.includes(pathName)
    ? MenulinksIMPlans
    : [];
  const MenuItems = links.includes(pathName)
    ? items
    : MenulinksSrms.includes(pathName)
    ? MenuItemsSrms
    : MenulinksTrusteePlans.includes(pathName)
    ? MenuItemsTrusteePlans
    : MenulinksIMPlans.includes(pathName)
    ? MenuItemsIMPlans
    : [];

  const showListChrome = Menulinks.includes(pathName);
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadUsers = async () => {
    if (isDownloading) return;
    try {
      setIsDownloading(true);
      const blob = (await dispatch(exportUsers())) as unknown as Blob;
      downloadBlobFile(blob, 'aif-onboarding-Users.xlsx');
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setIsDownloading(false);
    }
  };

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const [rmsRes, distCompany, distIndividual, trustees, ims, aif, amc] = await Promise.all([
          dispatch(getRMsList()) as unknown as Promise<newRmType | any[]>,
          dispatch(getDistributorsList({ type: 'company' })) as unknown as Promise<any[]>,
          dispatch(getDistributorsList({ type: 'individual' })) as unknown as Promise<any[]>,
          dispatch(getTrustessList()) as unknown as Promise<any[]>,
          dispatch(getFundManagersList()) as unknown as Promise<any[]>,
          dispatch(getAIFApproverList()) as unknown as Promise<any[]>,
          dispatch(getAmcAdminList()) as unknown as Promise<any[]>,
        ]);
        if (!alive) return;
        const rmsCount = Array.isArray(rmsRes)
          ? rmsRes.length
          : (rmsRes as newRmType)?.total ?? (rmsRes as newRmType)?.rms?.length ?? 0;
        setTabCounts({
          rms: rmsCount,
          distributors: (distCompany?.length || 0) + (distIndividual?.length || 0),
          trustees: Array.isArray(trustees) ? trustees.length : 0,
          ims: Array.isArray(ims) ? ims.length : 0,
          aifApprovers: Array.isArray(aif) ? aif.length : 0,
          amcAdmins: Array.isArray(amc) ? amc.length : 0,
        });
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
    return () => {
      alive = false;
    };
  }, [dispatch]);

  return (
    <UserManagementCommonLayout>
      <>
        {showListChrome && (
          <Box sx={{ mb: 2.5, px: { xs: 2, md: 0 } }}>
            <Breadcrumbs
              separator=">"
              aria-label="breadcrumb"
              sx={{
                mb: 1.5,
                '& .MuiBreadcrumbs-separator': { mx: 0.75, color: '#6C737F' },
                '.MuiTypography-root, .MuiLink-root': {
                  fontSize: 14,
                  color: '#111927',
                  fontFamily: 'Inter, sans-serif',
                },
              }}>
              <Link component={RouterLink} to="/dashboard" underline="hover" color="inherit">
                Home
              </Link>
              <Typography
                color="text.primary"
                sx={{ fontWeight: 500, color: '#6C737F !important' }}>
                User Management
              </Typography>
            </Breadcrumbs>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
                flexWrap: 'wrap',
              }}>
              <Typography
                component="h1"
                sx={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: 24,
                  fontWeight: 700,
                  color: 'text.primary',
                  lineHeight: 1.2,
                }}>
                User Management
              </Typography>
              <Button
                variant="outlined"
                startIcon={<FileDownloadOutlinedIcon />}
                onClick={handleDownloadUsers}
                disabled={isDownloading}
                sx={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 500,
                  fontSize: 14,
                  lineHeight: 1,
                  letterSpacing: 0,
                  textTransform: 'none',
                  color: '#2057A6',
                  borderColor: '#2057A6',
                  borderRadius: '8px',
                  px: 2,
                  py: 1,
                  bgcolor: '#FFFFFF',
                  '&:hover': {
                    borderColor: '#1A4A8C',
                    bgcolor: '#F8FAFC',
                  },
                }}>
                {isDownloading ? 'Downloading...' : 'Download User Data'}
              </Button>
            </Box>
          </Box>
        )}

        {showListChrome ? (
          <Box
            sx={{
              bgcolor: '#FFFFFF',
              borderRadius: '16px',
              border: '1px solid #E8ECF0',
              overflow: 'hidden',
              mx: { xs: 2, md: 0 },
              width: { xs: 'auto', md: '100%' },
              minWidth: 0,
              maxWidth: '100%',
            }}>
            <Hidden only="xs">
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                  px: 2,
                  borderBottom: '1px solid #E5E7EB',
                  overflowX: 'auto',
                  minWidth: 0,
                  maxWidth: '100%',
                  flexWrap: 'nowrap',
                }}>
                {MenuItems.map((itemList, index) => (
                  <UserManagementLayOutItems
                    key={index}
                    item={itemList.title}
                    link={itemList.routerLink}
                    count={tabCounts[itemList.countKey]}
                  />
                ))}
              </Box>
            </Hidden>
            <Hidden smUp={true}>
              <Box sx={{ px: 2, pt: 2, pb: 1 }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb: 2,
                    color: 'primary.main',
                  }}>
                  <PersonOutlineOutlinedIcon fontSize="medium" />
                  <Typography
                    sx={{ fontSize: 18, fontWeight: 600, pl: 1, fontFamily: 'Inter, sans-serif' }}>
                    User Management
                  </Typography>
                </Box>
                <FormControl fullWidth>
                  <InputLabel shrink id="user-items"></InputLabel>
                  <Select
                    labelId="user-items"
                    value={MenuItems[Menulinks.indexOf(pathName)].routerLink}
                    onChange={(e) => {
                      history.push(`${e.target.value}`);
                    }}
                    sx={{
                      color: 'primary.main',
                      fontWeight: 500,
                      fontFamily: 'Inter, sans-serif',
                    }}
                    IconComponent={(props) => (
                      <ArrowDropDownIcon
                        {...props}
                        sx={{
                          paddingRight: '13px',
                          color: '#2057A6 !important',
                          cursor: 'pointer',
                        }}
                        fontSize="large"
                      />
                    )}>
                    {MenuItems.map((itemlist, ind) => (
                      <MenuItem
                        sx={{ borderBottom: '1px solid #ccc', fontFamily: 'Inter, sans-serif' }}
                        value={itemlist.routerLink}
                        key={ind}>
                        {itemlist.title}
                        {typeof tabCounts[itemlist.countKey] === 'number'
                          ? ` (${tabCounts[itemlist.countKey]})`
                          : ''}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Hidden>
            <Routes historyLocationState={history.location.state} />
          </Box>
        ) : (
          <Routes historyLocationState={history.location.state} />
        )}
      </>
    </UserManagementCommonLayout>
  );
}
